import styled from "styled-components";

export const Container = styled.div`
  background: #ffffff;
  border-radius: 18px;
  border: 1.5px solid #e2e8f5;
  box-shadow: 0 4px 20px rgba(12, 21, 56, 0.05);
  display: flex;
  flex-direction: column;
  position: relative;
  transition: all 0.3s ease;
  overflow: visible;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 16px 36px rgba(12, 21, 56, 0.1);
    border-color: #cbd5e1;
  }

  &.popular-card {
    border-color: #2806f9;
    box-shadow: 0 12px 32px rgba(40, 6, 249, 0.14);

    &:hover {
      box-shadow: 0 20px 44px rgba(40, 6, 249, 0.22);
    }

    .card_header {
      background: linear-gradient(135deg, rgba(40, 6, 249, 0.08) 0%, rgba(79, 46, 255, 0.04) 100%);
    }

    .subs-btn {
      background: #2806f9;
      box-shadow: 0 4px 16px rgba(40, 6, 249, 0.35);

      &:hover {
        background: #1e03c2;
        box-shadow: 0 8px 24px rgba(40, 6, 249, 0.45);
      }
    }
  }

  .popular-badge {
    position: absolute;
    top: -14px;
    left: 50%;
    transform: translateX(-50%);
    background: linear-gradient(135deg, #2806f9 0%, #5d3bf6 100%);
    color: #ffffff;
    font-size: 11.5px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    padding: 4px 14px;
    border-radius: 20px;
    display: flex;
    align-items: center;
    gap: 5px;
    box-shadow: 0 4px 12px rgba(40, 6, 249, 0.3);
    z-index: 2;
  }

  .card_header {
    padding: 24px 20px 18px 20px;
    text-align: center;
    border-bottom: 1px solid #f0f3fa;
    border-radius: 18px 18px 0 0;
    background: #fafbfe;

    .plan-icon {
      width: 44px;
      height: 44px;
      margin: 0 auto 10px auto;
      background: rgba(40, 6, 249, 0.08);
      color: #2806f9;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 18px;
    }

    .plan-name {
      font-size: 18px;
      font-weight: 800;
      color: #0c1538;
      margin-bottom: 6px;
    }

    .screen-tag {
      display: inline-block;
      font-size: 11px;
      font-weight: 700;
      color: #2806f9;
      background: rgba(40, 6, 249, 0.08);
      padding: 3px 10px;
      border-radius: 12px;
      letter-spacing: 0.3px;
    }
  }

  .card_body {
    padding: 24px 20px 24px 20px;
    display: flex;
    flex-direction: column;
    flex-grow: 1;

    .price-wrap {
      display: flex;
      align-items: baseline;
      justify-content: center;
      gap: 2px;
      margin-bottom: 2px;

      .currency {
        font-size: 24px;
        font-weight: 700;
        color: #0c1538;
      }

      .price-num {
        font-size: 46px;
        font-weight: 800;
        color: #0c1538;
        line-height: 1;
      }

      .period {
        font-size: 14px;
        font-weight: 600;
        color: #6c7893;
      }
    }

    .billing-note {
      text-align: center;
      font-size: 11px;
      color: #7b86a0;
      margin-bottom: 20px;
    }

    .plan-features {
      list-style: none;
      padding: 0;
      margin: 0 0 24px 0;
      display: flex;
      flex-direction: column;
      gap: 10px;
      flex-grow: 1;

      li {
        display: flex;
        align-items: center;
        gap: 9px;
        font-size: 13px;
        line-height: 1.4;
        color: #1e293b;
        font-weight: 500;

        .check {
          color: #2806f9;
          font-size: 14px;
          flex-shrink: 0;
        }

        &.disabled-feature {
          color: #94a3b8;
          text-decoration: line-through;

          .check {
            color: #94a3b8;
            opacity: 0.6;
          }
        }
      }
    }

    .subs-btn {
      display: block;
      width: 100%;
      text-align: center;
      padding: 12px 18px;
      border-radius: 25px;
      font-size: 13.5px;
      font-weight: 700;
      text-decoration: none;
      background: #0c1538;
      color: #ffffff;
      transition: all 0.25s ease;
      cursor: pointer;

      &:hover {
        background: #2806f9;
        color: #ffffff;
        transform: translateY(-2px);
      }
    }
  }
`;
